import { render, staticRenderFns } from "./ProgramPageHeader.vue?vue&type=template&id=0a20eb40"
import script from "./ProgramPageHeader.vue?vue&type=script&lang=js"
export * from "./ProgramPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports